import React from "react";
import {Bar} from "react-chartjs-2";

const Graph = props => {
	const respostas = sumarizeAnswers( props.respostas );

	const data = {
		labels: ['Intrapessoal', 'Lógico-matemática', 'Interpessoal', 'Musical', 'Espacial/Visual', 'Corporal-cinestésica', 'Linguística'],
		datasets: [{
			label: 'Pontuação',
			data: respostas,
			backgroundColor: [
				'rgba(255, 99, 132, 0.2)',
				'rgba(54, 162, 235, 0.2)',
				'rgba(255, 206, 86, 0.2)',
				'rgba(75, 192, 192, 0.2)',
				'rgba(153, 102, 255, 0.2)',
				'rgba(255, 159, 64, 0.2)',
				'rgba(115,255,64, 0.2)'
			],
			borderColor: [
				'rgb(255, 99, 132)',
				'rgb(54, 162, 235)',
				'rgb(255, 206, 86)',
				'rgb(75, 192, 192)',
				'rgb(153, 102, 255)',
				'rgb(255, 159, 64)',
				'rgb(115,255,64)'
			],
			borderWidth: 1
		}]
	};

	const options = {
		scales: {
			yAxes: [{
				ticks: {
					beginAtZero: true
				}
			}]
		}
	}

	function sumarizeAnswers( respostas )
	{
		const dePara = [
			{"frase_1": 4, "frase_2": 5, "frase_3": 3, "frase_4": 1, "frase_5": 2, "frase_6": 6, "frase_7": 7},
			{"frase_1": 6, "frase_2": 1, "frase_3": 7, "frase_4": 2, "frase_5": 5, "frase_6": 3, "frase_7": 4},
			{"frase_1": 2, "frase_2": 1, "frase_3": 5, "frase_4": 6, "frase_5": 4, "frase_6": 3, "frase_7": 7},
			{"frase_1": 6, "frase_2": 2, "frase_3": 5, "frase_4": 4, "frase_5": 3, "frase_6": 1, "frase_7": 7},
			{"frase_1": 1, "frase_2": 4, "frase_3": 2, "frase_4": 6, "frase_5": 5, "frase_6": 7, "frase_7": 3}
		];

		const sum = [0, 0, 0, 0, 0, 0, 0];

		for ( let row of respostas ) {
			for ( let field in row ) {
				if ( field === 'pessoa' || field === 'grupo' || field === 'teste' ) continue;
				sum[ dePara[ row.grupo - 1 ][ field ] - 1 ] += parseInt( respostas[ row.grupo - 1 ][ field ] );
			}
		}

		return sum;
	}

	return <div className='whiteBoard'>
		<Bar data={data} options={options}/>
		<div className="legendas">
			<h3>Categoria I: Formas de inteligências relacionadas a objetos</h3>
			<p>
				<b>1. Lógico-matemática</b>: capacidade de solucionar problemas envolvendo números e outros elementos matemáticos, perceber a relação entre as coisas, saber, por exemplo, como um computador funciona. Envolve todas as ciências exatas. Exemplos de profissões: engenheiros, físicos, químicos, técnicos em informática e médicos. Albert Einstein é um exemplo de pessoa com inteligência lógico-matemática.<br/><br/>
				<b>2. Espacial/Visual</b>: habilidade para memorizar cenas, noção de espaço e direção, saber onde está e quais são as referências a sua volta, criatividade e imaginação. Exemplos de profissões: arquitetos, engenheiros e decoradores. Um bom exemplo é o arquiteto Oscar Niemeyer.<br/><br/>
				<b>3. Corporal-cinestésica</b>: capacidade de usar o corpo de maneiras diferentes e hábeis, saber como se movimentar, gostar de exercícios físicos, pessoas que desenvolvem essa inteligência costumam usar muitos gestos quando falam. Exemplos de profissões: atletas, dançarinos e atores. Essa aptidão pode ser encontrada em atletas como Pelé e Michael Jordan.<br/><br/>
			</p>
			<h3>Categoria II: Formas de inteligências isentas de objetos</h3>
			<p>
				<b>4. Linguística</b>: habilidade para lidar com as palavras, para expressar idéias, memorizar o que se fala,
				gostar e saber como falar, usar a linguagem para representar o mundo - é a inteligência responsável pela
				comunicação. Exemplos de profissões: políticos, professores, jornalistas, vendedores e escritores.
				Grandes autores, como Jorge Amado, têm grande potencial linguístico.<br/><br/>
				<b>5. Musical</b>: pessoas com o chamado ""ouvido absoluto"", capacidade de organizar sons de maneira
				criativa, ouvir uma melodia e não esquecer mais, tocar uma música que nunca tocou antes, reconhecer
				notas e acordes. Exemplo de profissões: músicos, cantores, compositores. Os compositores Beethoven e
				Mozart possuíam inteligência musical.<br/><br/>
			</p>
			<h3>Categoria III: Formas de inteligências relacionadas a pessoas</h3>
			<p>
				<b>6. Interpessoal</b>: habilidade de compreender os outros, se dar bem com as pessoas, saber se comunicar,
				ter empatia (saber o que o outro está sentindo), gostar de estar entre outras pessoas - indivíduos com
				inteligência interpessoal em evidência costumam ser bons líderes. Exemplos de profissões: psicólogos,
				advogados, assistentes sociais, apresentadores de TV e administradores. Silvio Santos, por exemplo, tem
				capacidade interpessoal.<br/><br/>
				<b>7. Intrapesssoal</b>: capacidade de relacionamento consigo mesmo, saber se entender, gostar de passar
				tempo sozinho, compreender os próprios sentimentos - relacionada com a auto-estima. Exemplos de
				profissões: psicólogos e filósofos. Os filósofos clássicos, como Platão, podem ser exemplos de inteligência
				intrapessoal.<br/><br/>

			</p>
		</div>
		<p>


		</p>
	</div>
}

export default Graph;